export default __webpack_public_path__ + "assets/icons/mark_exclamation.78f853bb.svg";